import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Outlet} from '@github-ui/react-router'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'

import {issuesLayoutRoute} from './issues-layout-route'
import {useRenderSidebar} from './render-issues-sidebar'

export function IssuesLayout() {
  const {owner, repo} = useRouteParams(issuesLayoutRoute)
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const sidebarLayoutEnabled = useRepoIssuesSidebarLayoutEnabled()

  const renderSidebarFn = useRenderSidebar(owner, repo, layoutPayload)

  // Flag on: the leaf (Labels) owns the lifted layout so it can hoist its
  // "New label" action into the page header; the parent is a thin passthrough.
  if (sidebarLayoutEnabled) {
    return <Outlet />
  }

  // Flag off: legacy parent-owned layout — identical to main.
  return (
    <BaseAnalyticsWrapper category={'Repository Label Index'} appName={'issues'}>
      <RepoIssuesPageLayout
        dialogTitle="Labels"
        title="Labels"
        renderSidebar={renderSidebarFn}
        initialExpanded={layoutPayload?.sidebar_expanded ?? undefined}
      >
        <Outlet />
      </RepoIssuesPageLayout>
    </BaseAnalyticsWrapper>
  )
}
